import { ActionTypes, EmailAuditAction, EmailAuditPage } from './actions';

export interface EmailAuditState {
  data: EmailAuditPage | null;
  loading: boolean;
  error: string | null;
}

const initialState: EmailAuditState = {
  data: null,
  loading: false,
  error: null,
};

export default function emailAuditReducer(
  state: EmailAuditState = initialState,
  action: EmailAuditAction,
): EmailAuditState {
  switch (action.type) {
    case ActionTypes.FETCH_AUDIT_REQUEST:
      return { ...state, loading: true, error: null };
    case ActionTypes.FETCH_AUDIT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case ActionTypes.FETCH_AUDIT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
